<template>
  <NotificationTemplate :notification="notification">
    <template #pic>
      <Avatar
        :src="notification.initiatorAvatarSrc || null"
        :gap="notification.getInitials()"
      />
    </template>
    <template #title>
      <!-- The Idea design keeps the whole sentence on one line, with the key at the end. -->
      <BaseSubHeading
        v-if="notification.isIdea"
        size="large"
        color="monochrome-06"
        darkColor="monochrome-03"
        weight="400"
      >
        You have been mentioned by
        <span class="notification__update-item__initiator idea-comments__initiator">{{
          notification.initiatorFullName
        }}</span>
        to
        <a
          class="link is-large"
          target="_blank"
          :href="notification.resourceUrl"
        >
          {{ notification.displaySequenceNumber }}:
        </a>
      </BaseSubHeading>
      <template v-else>
        <BaseSubHeading
          size="large"
          color="monochrome-06"
          darkColor="monochrome-03"
          weight="400"
        >
          <a
            class="link is-large"
            target="_blank"
            :href="notification.resourceUrl"
          >
            {{ notification.displaySequenceNumber }}
          </a>
        </BaseSubHeading>
        <BaseSubHeading
          size="large"
          color="monochrome-06"
          darkColor="monochrome-03"
          weight="400"
        >
          You have been mentioned by
          <span class="notification__update-item__initiator">{{
            notification.initiatorFullName
          }}</span>
        </BaseSubHeading>
      </template>
    </template>
    <template #content>
      <BaseSubHeading
        size="medium"
        color="monochrome-06"
        darkColor="monochrome-03"
        weight="400"
        className="notification__desc"
      >
        <ReferencedText
          :resetStyle="true"
          :html="notification.text"
        />
      </BaseSubHeading>

      <NotificationAttachmentFiles
        v-if="notification.attachments.length"
        :attachments="notification.attachments"
        :itemUrl="notification.resourceUrl"
        :attachmentsCount="notification.attachmentsCount"
      />
    </template>
  </NotificationTemplate>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component"
import { Prop, Ref } from "vue-property-decorator"

import Avatar from "@/components/Avatar/index.vue"
import NotificationAttachmentFiles from "@/components/Notification/components/NottificationAttacmentFiles.vue"
import NotificationTemplate from "@/components/Notification/NotificationTemplate.vue"

import { NotificationComment } from "@/models/Notification/NotificationComment"

import { ReferencedText } from "../../Reference"

@Options({
  name: "USER_MENTION",
  components: {
    NotificationTemplate,
    Avatar,
    ReferencedText,
    NotificationAttachmentFiles
  }
})
export default class USER_MENTION extends Vue {
  @Prop() readonly notification: NotificationComment
  @Ref("text") readonly el: HTMLDivElement
}
</script>
